import { Modal } from '@tryhackme/thm-ui-components';
import { type ComponentProps, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledContainer, StyledDescription, StyledImageContainer, StyledTextContainer, StyledTitle } from './no-vm-modal.styles';
type NoVMModalProps = ComponentProps<typeof Modal>;
export const NoVMModal = (props: NoVMModalProps) => {
  const {
    open,
    onOpenChange
  } = props;
  const [trackEvent] = useTrackEventMutation();
  const location = useLocation();
  useEffect(() => {
    if (open) {
      void trackEvent({
        event: 'mobile-show-no-vm-modal',
        properties: {
          pathname: location.pathname
        }
      });
    }
  }, [open, trackEvent, location.pathname]);
  return <Modal open={open} onOpenChange={onOpenChange} minHeight="61.6rem" data-sentry-element="Modal" data-sentry-component="NoVMModal" data-sentry-source-file="no-vm-modal.tsx">
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="no-vm-modal.tsx">
        <StyledImageContainer data-sentry-element="StyledImageContainer" data-sentry-source-file="no-vm-modal.tsx">
          <img src={'/images/svgs/mobile/desktop.svg'} alt="Desktop computer" />
        </StyledImageContainer>

        <StyledTextContainer data-sentry-element="StyledTextContainer" data-sentry-source-file="no-vm-modal.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="no-vm-modal.tsx">This task requires a computer</StyledTitle>

          <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="no-vm-modal.tsx">
            Virtual machines aren’t available on mobile. Please switch to a desktop or laptop with a minimum width of
            960 pixels (9 inches) to complete this task.
          </StyledDescription>
        </StyledTextContainer>
      </StyledContainer>
    </Modal>;
};